import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMsgComponent } from './error-msg.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ErrorMsgComponent],
  exports: [ErrorMsgComponent],
  imports: [CommonModule, MatIconModule]
})
export class ErrorMsgModule {}
